import moduleConfig from './module-config';
import netsCallwaiting from './nets-callwaiting';

export default angular
  .module('app.settings-callwaiting', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsCallwaiting', netsCallwaiting);
